import { Component, Injectable, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { RolesAware } from '../../../domain/authorization/roles-aware.class';
import { UserAware, UserAwareBase } from '../../../domain/model/user/user-aware.class';
import { AuthService } from '../../security/authorization/auth.service';
import { VerificationService } from '../service/verification.service';

@Component({
    selector: 'my-verification',
    template: require('./verification.component.html'),
    styles: [require('./verification.component.scss')],
    host: {
        '[class.open]' : 'open',
    },
})
@Injectable()
export class VerificationComponent extends RolesAware(UserAware(UserAwareBase)) implements OnInit, OnDestroy {
    public errors: Error | undefined;
    public form: FormGroup;
    public open: boolean = false;
    public previousVerificationDate: Date;
    public reverifying: boolean = false;
    public saving: boolean = false;
    public verified: boolean = false;
    private subscriptions: Subscription;

    constructor(
        readonly authService: AuthService,
        readonly formBuilder: FormBuilder,
        readonly verificationService: VerificationService,
    ) {
        super(authService);
        this.subscriptions = new Subscription();
        this.open = verificationService.getPanelStatus();
        this.reverifying = verificationService.getReverifyingStatus();
    }

    ngOnInit(): void {
        this._setupForm();
        this._listenForConfigChanges();
        this._getVerificationDetails();
    }

    ngOnDestroy(): void {
        if (this.subscriptions) this.subscriptions.unsubscribe();
    }

    private _setupForm(): void {
        this.form = this.formBuilder.group({
            notes: new FormControl(''),
        });
    }

    private _listenForConfigChanges(): void {
        this.subscriptions.add(
            this.verificationService.configChanges.subscribe(() => {
                this.verified = false;
                this.form.reset();
                this._getVerificationDetails();
            })
        );
    }

    private _getVerificationDetails(): void {
        this.form.enable();
        this.subscriptions.add(
            this.verificationService.getVerificationDetails().subscribe(data => {
                if (data.exists && data.verifiedByName) {
                    this.verified = true;
                    this.form.controls['notes'].patchValue(data.notes);
                    this.previousVerificationDate = data.verifiedDate;
                    if (!this.reverifying) {
                        this.form.disable();
                    }
                } else {
                    this.verified = false;
                    this.form.reset();
                }
            }, () => {
                this.verified = false;
                this.form.reset();
            })
        );
    }

    public toggle(event: Event): void {
        event.preventDefault();
        this.open = !this.open;
        this.verificationService.setPanelStatus(this.open);
    }

    public saveNotes(): void {
        if (this.form.valid) {
            this.saving = true;
            this.errors = undefined;
            this.verificationService.postNotes(this.form.value)
                .subscribe(() => {
                    this.saving = false;
                    this.verified = true;
                    this.errors = undefined;
                    this.previousVerificationDate = new Date();
                    if (!this.reverifying) {
                        this.form.disable();
                    }
                },
                err => {
                    this.errors = err;
                    this.saving = false;
                });
        }
    }

    public setReverifying(val: boolean) {
        this.verificationService.setReverifying(val);
        this.reverifying = this.verificationService.getReverifyingStatus();
        if (this.reverifying) {
            this.form.enable();
        } else {
            this.form.disable();
        }
    }

    public formatDate(date): string {
        if (date) {
            const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
            return date.toLocaleDateString ? date.toLocaleDateString('en-US', options) : date;
        }
        return '';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/verification/components/verification.component.ts